const authenticationDataUpdate = 'ahv-event AuthenticationDataUpdate';
const modelDataUpdate = 'ahv-event ModelDataUpdate';
const unauthorized = 'ahv-event Unauthorized';
const fetchingModel = 'ahv-event FetchingModel';
const invalidCadastreKeySubmitted = 'ahv-event InvalidCadastreKeySubmitted';
const serviceUnavailableOrInternalServerError = 'ahv-event ServiceUnavailableOrInternalServerError';
const genericError = 'ahv-event GenericError';

export {authenticationDataUpdate as AuthenticationDataUpdate};
export {modelDataUpdate as ModelDataUpdate};
export {unauthorized as Unauthorized};
export {fetchingModel as FetchingModel};
export {invalidCadastreKeySubmitted as InvalidCadastreKeySubmitted};
export {serviceUnavailableOrInternalServerError as ServiceUnavailableOrInternalServerError};
export {genericError as GenericError};



/** WEBPACK FOOTER **
 ** ./src/Events.ts
 **/